/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { useAppSelector, } from '../redux/hook.ts';
import VotingCard from '../components/voting_components/VotingCard.tsx';
import VotingService from '../api_handlers/services/VotingService.ts';
import { useToast } from '../components/base_components/ToastContext.tsx';
import { useNavigate } from 'react-router-dom';
import CardHeader from '../components/common_components/CardHeader.tsx';
import CardContainer from '../components/common_components/CardContainer.tsx';


const Voting = () => {
  const [showVotingScreen, setShowVotingScreen] = useState(false);
  const [team, setTeam] = useState({ id: 0, teamName: '', backgroundImage: '' });
  const [isSelfVoted, setIsSelfVoted] = useState(false);
  const [isSelfVotingSessionCompleted, setIsSelfVotingSessionCompleted] = useState(false);
  const [waitingForFacilitator, setWaitingForFacilitator] = useState(true);
  const [isLoggedInTeamGettingVotes, setIsLoggedInTeamGettingVotes] = useState(false);
  const [isVotingDoneForAllTeams, setIsVotingDoneForAllTeams] = useState(false);
  const { showToast } = useToast();
  const navigate = useNavigate();
  const session = useAppSelector((state) => state.session.session);
  const loggedInTeam = useAppSelector((state) => state.team.team);
  const intervalId = useRef<NodeJS.Timeout | null>(null);
  const selfVotingIntervalId = useRef<NodeJS.Timeout | null>(null);

  const getTeamForVoting = () => {
    var sessionId = session?.sessionId;
    var gaminarCode = session?.gaminarCode;
    VotingService.getTeamForVoting(sessionId).then((data) => {
      if (data.data == null) {
        showToast(data.message);
        if (intervalId.current) {
          clearInterval(intervalId.current);
          intervalId.current = null;
        }
        setWaitingForFacilitator(false);
        setShowVotingScreen(false);
        setIsLoggedInTeamGettingVotes(false);
        setIsVotingDoneForAllTeams(true);
        setTeam({ teamName: loggedInTeam?.teamName, backgroundImage: loggedInTeam?.backgroundImage, id: -1 });

        return;
      }
      var teamObj = data.data.team;
      console.log("TEAM OBJ", teamObj);
      console.log("TEAM", team);
      console.log("Logged IN Team", loggedInTeam);
      if (team.id !== teamObj.id) {
        setTeam(teamObj);
        if (intervalId.current) {
          clearInterval(intervalId.current);
          intervalId.current = null;
        }
        setWaitingForFacilitator(false);

        if (loggedInTeam?.id === teamObj.id) {
          setShowVotingScreen(false);
          setIsLoggedInTeamGettingVotes(true);
          setWaitingForFacilitator(false);
          console.log("setting timeout", intervalId.current);
          if (!intervalId.current) {
            intervalId.current = setInterval(getTeamForVoting, 5000);
          }
        }
        else {
          setIsLoggedInTeamGettingVotes(false);
          setShowVotingScreen(true);
        }



      }
      else {
        if (loggedInTeam?.id === teamObj.id) {
          setShowVotingScreen(false);
          setIsLoggedInTeamGettingVotes(true);
          setWaitingForFacilitator(false);
        }
        else {
          setWaitingForFacilitator(true);

        }
        if (!intervalId.current) {
          intervalId.current = setInterval(getTeamForVoting, 5000);
        }
      }
    }).catch((err) => {
      console.log(err);
      if (err.response.data?.statusCode === 400 && err.response.data?.message != null) {
        showToast(err.response.data.message, "error");
        navigate(`/LandingPage`);
      }
      else { showToast(err.response.data, "error"); navigate(`/VotingSession?sessionCode=${gaminarCode}`); }
    });
  }

  const checkIfTeamVotedForItSelf = () => {
    var sessionId = session?.sessionId;
    var teamId = loggedInTeam?.id;

    VotingService.checkIfTeamVotedForTeam(sessionId, teamId, teamId).then((res) => {
      console.log("res.data.IsVoteCompleted", res.data.isVoteCompleted)
      if (res.data.isVoteCompleted) {
        //Has voted for itself
        setShowVotingScreen(false);
        setIsSelfVoted(true);
        setWaitingForFacilitator(true);
        getIsSelfVotingSessionCompleted();
      }
      else {
        //Check if self-voting session is already completed (facilitator skipped)
        VotingService.isSelfVotingSessionCompleted(sessionId).then((sessionRes) => {
          if (sessionRes.data.isVoteCompleted) {
            //Self-voting was skipped, move to team voting phase
            setIsSelfVotingSessionCompleted(true);
            setIsSelfVoted(true);
            setWaitingForFacilitator(false);
            getTeamForVoting();
          } else {
            //Has not voted for itself, show the voting screen.
            var teamObj = res.data.team.teamObj;
            console.log("CHECK IF TEAM IDS are not SAME", team.id);
            console.log("CHECK IF TEAM IDS are not SAME", teamObj.id);
            setTeam(teamObj);
            setWaitingForFacilitator(false);
            setShowVotingScreen(true);
          }
        });
      }
    }).catch((err) => {

    });
  }


  const getIsSelfVotingSessionCompleted = () => {
    var sessionId = session?.sessionId;
    VotingService.isSelfVotingSessionCompleted(sessionId).then((res) => {
      if (res.data.isVoteCompleted) {
        setIsSelfVotingSessionCompleted(true);
        setIsSelfVoted(true);
        if (selfVotingIntervalId.current) {
          clearInterval(selfVotingIntervalId.current);
          selfVotingIntervalId.current = null;
        }
        getTeamForVoting();
      }
      else {
        setIsSelfVotingSessionCompleted(false);
        if (!selfVotingIntervalId.current) {
          selfVotingIntervalId.current = setInterval(getIsSelfVotingSessionCompleted, 5000);
        }
      }
    });
  }

  useEffect(() => {
    //Step 1
    // Check if the logged in team has voted for itself or not, it mean that all the member of that team has voted
    //   for their own team.
    // If team has voted for it's team. We check 
    //     if all the other teams has voted for their own team or not
    //        we need to show them a waiting screen, which says that. Please wait for the others team to vote.
    //Step 2
    // Once all the other teams has voted for their team, we need to get first voting team.
    //  If the team that has been voted for is the same as the logged in team, we need to show them a message that.
    //     Please stand up as you will be voted now......
    //  else we just need to show them the voting screen.
    // Once the team submitted the voting we will again show them a waiting screen and wait for the facilitator to move to
    //    next team.

    //Step 1: Self Voting
    checkIfTeamVotedForItSelf();
    //getTeamForVoting();

    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
      if (selfVotingIntervalId.current) {
        clearInterval(selfVotingIntervalId.current);
      }
    };
  }, []);


  const moveToNextTeam = async () => {
    // if (isSelfVoted && loggedInTeam?.id == team.id) {
    //   setWaitingForFacilitator(true);
    //   intervalId = setInterval(getTeamForVoting, 5000);
    // }
    //else {
    VotingService.submitVotes({ sessionId: session?.sessionId, votedByTeamId: loggedInTeam?.id, votedForTeamId: team.id }).then((res) => {
      console.log("MoveToNextTeam Res", res);
      setWaitingForFacilitator(true);
      setShowVotingScreen(false);
      if (loggedInTeam?.id === team.id) {
        setIsSelfVoted(true);
        getIsSelfVotingSessionCompleted();
        // if (isSelfVotingSessionCompleted) {
        //   if(!intervalId){

        //   }
        //   intervalId = setInterval(getTeamForVoting, 5000);
        // }
      }
      else {
        if (!intervalId.current) {
          intervalId.current = setInterval(getTeamForVoting, 5000);
        }
      }
    }).catch((err) => {

    })
  }

  // }

  // useEffect(() => {
  //     const fetchTeams = async () => {
  //       try {
  //         console.log("Session", session);
  //         var data = await sessionService.getTeams(session);
  //         console.log(data.data);
  //         setTeams(data.data);
  //         setLoading(false); 
  //       } catch (err) {
  //         setError('Failed to load teams');
  //         setLoading(false);
  //       }
  //     };

  //     fetchTeams();
  //   }, []);

  return (
    <CardContainer backgroundImageUrl={`/img/team-background/warriorbg.png`}>
      <Card sx={{
        width: { xs: '98%', sm: '95%', md: '50rem', lg: '56rem' },
        maxWidth: { xs: '98vw', sm: '95vw' },
        padding: 0,
        background: 'url(/img/bg2.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backdropFilter: 'blur(0.3rem)',
        borderRadius: { xs: '0.75rem', sm: '1rem', md: '1.25rem' },
        border: '0.25rem solid rgba(139, 69, 19, 0.8)',
        boxShadow: '0 1.5rem 4rem rgba(0, 0, 0, 0.9), 0 0 3rem rgba(139, 69, 19, 0.5), inset 0 0.25rem 0.5rem rgba(255, 255, 255, 0.15)',
        zIndex: 1,
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(135deg, rgba(101, 67, 33, 0.25) 0%, rgba(139, 69, 19, 0.2) 100%)',
          pointerEvents: 'none',
          zIndex: 0,
        }
      }} variant="outlined">
        <CardContent sx={{ padding: 0, '&:last-child': { paddingBottom: 0 }, width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
          <Box sx={{ width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
            <CardHeader teamName={team.teamName}></CardHeader>
            <Box sx={{ padding: { xs: '2rem 1rem', md: '3rem 2rem' }, width: '100%', boxSizing: 'border-box', position: 'relative', zIndex: 1 }}>
              {isVotingDoneForAllTeams ? (
                <Typography variant="h5" sx={{
                  fontFamily: "'Philosopher', sans-serif",
                  color: '#FFD700',
                  textAlign: 'center',
                  fontWeight: 700,
                  fontSize: { xs: '1.3rem', md: '1.5rem' },
                  textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                  lineHeight: 1.5,
                  padding: { xs: '1.5rem', md: '2rem' },
                  background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.3) 0%, rgba(184, 134, 11, 0.8) 100%)',
                  borderRadius: '1rem',
                  border: '0.2rem solid rgba(255, 215, 0, 0.5)',
                  boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.4)',
                }}>
                  🎉 Congratulations! Voting for all teams has concluded, and the results will be announced soon.
                </Typography>
              ) : (<></>)}
              {waitingForFacilitator ? (
                <Typography variant="h5" sx={{
                  fontFamily: "'Philosopher', sans-serif",
                  color: '#FFD700',
                  textAlign: 'center',
                  fontWeight: 700,
                  fontSize: { xs: '1.3rem', md: '1.5rem' },
                  textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                  lineHeight: 1.5,
                  padding: { xs: '1.5rem', md: '2rem' },
                  background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.3) 0%, rgba(184, 134, 11, 0.8) 100%)',
                  borderRadius: '1rem',
                  border: '0.2rem solid rgba(255, 215, 0, 0.5)',
                  boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.4)',
                }}>
                  ⏳ Please wait for the Facilitator...
                </Typography>
              ) : (<></>)}

              {!isSelfVotingSessionCompleted && !showVotingScreen ? (
                <Typography variant="h5" sx={{
                  fontFamily: "'Philosopher', sans-serif",
                  color: '#FFD700',
                  textAlign: 'center',
                  fontWeight: 700,
                  fontSize: { xs: '1.3rem', md: '1.5rem' },
                  textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                  lineHeight: 1.5,
                  padding: { xs: '1.5rem', md: '2rem' },
                  background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.3) 0%, rgba(184, 134, 11, 0.8) 100%)',
                  borderRadius: '1rem',
                  border: '0.2rem solid rgba(255, 215, 0, 0.5)',
                  boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.4)',
                }}>
                  ⏳ Please wait for the other teams to place their votes.
                </Typography>
              ) : (<></>)}

              {isLoggedInTeamGettingVotes ? (
                <Typography variant="h5" sx={{
                  fontFamily: "'Philosopher', sans-serif",
                  color: '#FFD700',
                  textAlign: 'center',
                  fontWeight: 700,
                  fontSize: { xs: '1.3rem', md: '1.5rem' },
                  textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                  lineHeight: 1.5,
                  padding: { xs: '1.5rem', md: '2rem' },
                  background: 'linear-gradient(135deg, rgba(218, 165, 32, 0.3) 0%, rgba(184, 134, 11, 0.8) 100%)',
                  borderRadius: '1rem',
                  border: '0.2rem solid rgba(255, 215, 0, 0.5)',
                  boxShadow: '0 0 1.5rem rgba(218, 165, 32, 0.4)',
                }}>
                  👀 All eyes on you! Stand tall—your team is in the spotlight now!
                </Typography>
              ) : (<></>)}

              {!isSelfVoted && !isSelfVotingSessionCompleted && loggedInTeam?.id === team.id ? (
                <>
                  <Typography variant='h5' sx={{
                    fontFamily: "'Philosopher', sans-serif",
                    color: '#FFD700',
                    textAlign: 'center',
                    fontWeight: 700,
                    fontSize: { xs: '1.3rem', md: '1.5rem' },
                    textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                    marginBottom: '1.5rem',
                  }}>
                    Which of the below attributes you think {team.id === loggedInTeam?.id ? "your team" : team.teamName} has displayed?
                  </Typography>
                </>
              ) : (<></>)}

              {showVotingScreen ? (
                <>
                  {loggedInTeam?.id !== team.id ? (
                    <Typography variant='h5' sx={{
                      fontFamily: "'Philosopher', sans-serif",
                      color: '#FFD700',
                      textAlign: 'center',
                      fontWeight: 700,
                      fontSize: { xs: '1.3rem', md: '1.5rem' },
                      textShadow: '0.15rem 0.15rem 0.3rem rgba(0,0,0,0.9), 0 0 0.8rem rgba(255, 215, 0, 0.6)',
                      marginBottom: '1.5rem',
                    }}>
                      Do you think {team.teamName} have shown these attributes?
                    </Typography>) : (<></>)}
                  <VotingCard moveToNextTeam={moveToNextTeam} voteForTeamId={team.id} isSelfVoted={isSelfVoted} />
                </>
              ) : (<></>)}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </CardContainer>
    // <Card variant="outlined" sx={{ justifyItems: 'center' }}>
    //     <Box sx={{ p: 2 }}>

    //         <SubmitButton id='btnSubmitVoting' loading={false} loadingText='Submitting' text='Submit'>
    //         </SubmitButton>
    //     </Box>
    // </Card>
  );
};

export default Voting;